import { ForgeParticipant } from "@supernova-studio/model";
import { DTOUser } from "../users";
import { DTOForgeAgent } from "./agent";
import { z } from "zod";
export const DTOForgeParticipant = ForgeParticipant.omit({
    agent: true,
    user: true,
}).extend({
    agent: DTOForgeAgent.optional(),
    user: DTOUser.optional(),
});
export const DTOCreateForgeParticipant = DTOForgeParticipant.omit({
    projectIterationId: true,
    agent: true,
    user: true,
});
export const DTOUpdateForgeParticipant = DTOCreateForgeParticipant.extend({
    id: z.string(),
});
export const DTOCreateForgeParticipantResponse = z.object({
    participant: DTOForgeParticipant,
});
export const DTOUpdateForgeParticipantResponse = z.object({
    participant: DTOForgeParticipant.nullable(),
});
export const DTODeleteForgeParticipantResponse = z.object({
    ok: z.literal(true),
});
export const DTOForgeParticipantsListResponse = z.object({
    participants: z.array(DTOForgeParticipant),
});
export const DTOForgeParticipantGetResponse = z.object({
    participant: DTOForgeParticipant.nullable(),
});
